export enum DecisionButtonType {
  Accept = 'accept',
  Decline = 'decline',
}
